<template>
  <v-app>
    <v-content class="login-form">
      <v-container>
        <v-row>
          <v-col justify-self="center">
            <div class="display-1 text-center atlas-brand primary--text">
              atlas
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            sm="6"
            offset-sm="3"
            md="4"
            offset-md="4"
            xl="2"
            offset-xl="5"
          >
            <v-card>
              <v-card-title
                v-t="'auth.signup'"
                class="justify-center"
              />

              <v-card-text>
                <v-alert
                  color="error"
                  :value="!!error"
                >
                  {{ error }}
                </v-alert>

                <v-form v-model="validForm">
                  <v-text-field
                    v-model.trim="email"
                    label="Email"
                    prepend-icon="email"
                    autofocus
                    :rules="[ required, isEmail ]"
                  />

                  <v-text-field
                    v-model="password"
                    label="Password"
                    prepend-icon="lock"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :type="showPassword ? 'text' : 'password'"
                    :rules="[ required ]"
                    @click:append="showPassword = !showPassword"
                  />
                </v-form>
              </v-card-text>

              <v-card-actions class="px-12 py-6">
                <v-btn
                  v-t="'auth.signup'"
                  block
                  depressed
                  color="primary"
                  :disabled="!validForm || loading"
                  :loading="loading"
                  @click="createUser"
                />
              </v-card-actions>

              <v-divider />

              <p
                v-t="'auth.alreadyMember'"
                class="text-center grey--text my-2"
              />

              <v-card-actions class="px-12 pb-6">
                <v-btn
                  v-t="'auth.signin'"
                  block
                  outlined
                  :disabled="loading"
                  :to="{ name: 'login' }"
                />
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { BSON } from 'mongodb-stitch-browser-sdk'

import { db, login, registerWithEmail } from '@/plugins/stitch'
import { isEmail, required } from '@/utils/rules'

export default {
  name: 'Signup',
  data () {
    return {
      email: this.$route.query.e,
      error: null,
      loading: false,
      password: this.$route.query.p,
      showPassword: false,
      stream: null,
      validForm: false,
      watchdog: null
    }
  },
  beforeDestroy () {
    if (this.stream) { this.stream.close() }
    if (this.watchdog) { clearTimeout(this.watchdog) }
  },
  methods: {
    isEmail,
    required,
    async createUser () {
      this.loading = true
      this.error = null

      try {
        // signup user, return nothing
        await registerWithEmail(this.email, this.password)

        // after signup the user is not automatically loggedin
        const user = await login(this.email, this.password)

        // Wait for account creation
        this.stream = await db
          .collection('users')
          .watch([ new BSON.ObjectID(this.$currentUser.id) ])

        this.stream.onNext((event) => {
          this.goHome()
        })

        // check if the account is created immediately
        let newUser = await db
          .collection('users')
          .findOne({ _id: new BSON.ObjectID(user.id) })

        if (newUser) {
          this.goHome()
        } else {
          // if after some time we are still here
          // something strange occurred but most likely the signup succeeded
          // so give it a try and go home
          this.watchdog = setTimeout(this.goHome, 8000)
        }
      } catch (error) {
        this.error = error.message
        this.loading = false
      }
    },
    goHome () {
      if (this.stream) { this.stream.close() }
      if (this.watchdog) { clearTimeout(this.watchdog) }
      this.$store.dispatch('doFirstLoad')
      this.$router.push('/')
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
</style>
